<template>
	<section class="small-12 disclaimer flex">
        <p class="small-12 large-9 flex">
            Disclaimer: Hey! Welcome to our disclaimer. Here's what you need to 
            know to safely consume this blog post: We do our best to make sure 
            information is accurate as of the date of publication, but things do 
            change quickly sometimes. Any outbound links in this post will take 
            you away from Nestd.io, to external sites in the wilds of the internet; 
            Nestd does not endorse any linked-to websites; and we didn't pay/barter 
            with/bribe anyone to appear in this post. Individual situations will differ; 
            consult your favorite real estate, finance, tax or legal professional for 
            specific advice. And as much as we wish we could control the cost of things, 
            any prices in this article are just estimates. Actual prices are up to 
            retailers, manufacturers, and other people who've been granted magical 
            powers over digits and dollar signs.
        </p>
    </section>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Disclaimer',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>